//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ConfirmDialog from 'ui-kit/src/components/ConfirmDialog';

export default {
    constants() {
        return {
            columns: [
                { name: 'name', field: r => this.$t(`settings.${r.key}`), align: 'left', sortable: true },
                { name: 'value', field: 'value', align: 'left', sortable: false },
            ],
        };
    },

    data() {
        return {
            editSettings: null,
            isDirty: false,
        };
    },

    watch: {
        editSettings: {
            handler(val, oldVal) {
                // Mark as dirty if editSettings stayed the same, but something changed within
                if (val === oldVal) {
                    this.isDirty = true;
                }
            },
            deep: true,
        },
    },

    methods: {
        getSetting(key) {
            return this.editSettings.find(s => s.key === key);
        },
        initEdit() {
            this.editSettings = _.cloneDeep($.settings.filter(s => s.type !== 'hidden'));
            this.isDirty = false;
        },
        async saveAll() {
            $.settings = await $.apiUpdateMany('settings', this.editSettings);

            this.initEdit();

            notifyOk("Nastavení bylo uloženo.");
        },
        purgeAllAlerts() {
            this.$q.dialog({
                component: ConfirmDialog,
                title: 'Smazat všechna upozornění?',
                message: 'Opravdu chcete nenávratně smazat všechna upozornění všech uživatelů?',
                okLabel: 'Smazat',
                cancelLabel: 'Storno',
            }).onOk(async () => {
                await axios.post('/alerts/purge');
            });
        },
    },

    @cancellableFetch
    async mounted() {
        // Note: Fetching all to avoid updateIn issues caused by lack of ID
        await $.fetchAllFull('settings');

        this.initEdit();
    },
};
